export enum Role {
    User = 'User',
    Assistant = 'Assistant',
    Tool = 'Tool',
}

export enum ResponseType {
    Chat = 'Chat',
    Citation = 'Citation',
}

export interface Citation {
    title: string;
    absolutePath: string;
    content: string;
    id: number;
    index: number;
    citationReference: string;
}

export interface MessageWithText {
    content: string;
    timestamp: string;
    role: Role.User | Role.Assistant;
    responseType: ResponseType.Chat;
}

export interface MessageWithTextAndCitations extends MessageWithText {
    citations?: Citation[];
}

export interface CountryItem {
    value: string;
    isCountry: boolean;
    id: string;
}

export type CountryList = CountryItem[];

export enum NegotiateWebsocketUrlHubs {
    IndexerNotifications = 'IndexerNotifications',
    AvatarVoiceStream = 'AvatarVoiceStream',
}

export interface NegotiateWebsocketUrlResponse {
    createdAt: string;
    expiringAt: string;
    hub: string;
    expirationTime: string;
    url: string;
}

export interface RawSpeechTokenResponse {
    isPublicNetworkAccessEnabled: boolean;
    createdAt: string;
    expiringAt: string;
    expirationTime: string;
    token: string;
    hostUrl: string;
    sttEndpoint: string;
}

export type MessageFromWebsocket = {
    status: string;
    message: string;
};

export interface FilesUploadResponse {
    allSuccess: boolean;
    successedUploads: string[];
    failedUploads: string[];
}

export interface Prompt {
    promptId: string;
    label: string;
    text: string;
}

export interface RoleWithPrompts {
    id: string;
    role: string;
    agentId: string;
    prompts: Prompt[];
}

export type RolesWithPrompts = RoleWithPrompts[];

export interface PromptGroup {
    orderNumber: number;
    group: string;
    prompts: Prompt[];
    id: string;
}

export type PromptGroups = PromptGroup[];
